import { Entity, FieldType, PersistenceType } from 'gossamer-unified';
import { FeedbackForm } from './FeedbackForm';

export interface FeedbackFormQuestionRow {
  id: number;
  feedback_form_id: number;
  seq: number;
  question_type: string;
  title: string;
  subtitle: string;
  is_mandatory: boolean;
  standard_field: string;
}

export const FeedbackFormQuestion: Entity<FeedbackFormQuestionRow> = {
  id: 'FeedbackFormQuestion',
  title: 'Feedback Form Question',
  service: 'main',
  rowLabel: (row: FeedbackFormQuestionRow) => row.title,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.feedback_form_question',
  },
  security: [
    { role: 'user', action: 'read', access: 'all' },
    { role: 'admin', action: 'read', access: 'all' },
    {
      role: 'admin',
      action: 'all',
      access: 'conditional',
      condition: `feedback_form_id IN (SELECT id FROM public.feedback_form WHERE institution_id = {adminInstitutionId})`,
    },
    { role: 'staff', action: 'all', access: 'all' },
  ],
  fields: {
    id: {
      seq: 5,
      type: FieldType.Integer,
      label: 'Id',
      persistence: PersistenceType.BackEndManaged,
      mandatory: true,
      autoIncrement: true,
    },
    feedback_form_id: {
      seq: 10,
      type: FieldType.Reference,
      label: 'Feedback Form',
      mandatory: true,
      refEntity: FeedbackForm,
    },
    seq: {
      seq: 15,
      type: FieldType.Integer,
      label: 'Seq',
      description: 'Defines the order that that questions appear',
      mandatory: true,
      listColumn: true,
    },
    question_type: {
      seq: 20,
      type: FieldType.Options,
      label: 'Field Type',
      mandatory: true,
      listColumn: true,
      options: [
        { id: 'star_rating', label: 'star rating' },
        { id: 'yes_no', label: 'yes/no' },
        { id: 'short_text', label: 'short text box (one line)' },
        { id: 'long_text', label: 'long text box (multiple lines)' },
      ],
    },
    title: {
      seq: 25,
      label: 'Title Text',
      type: FieldType.Text,
      mandatory: true,
      listColumn: true,
      maxLength: 80,
    },
    subtitle: {
      seq: 30,
      label: 'Subtitle Text',
      type: FieldType.Text,
      listColumn: true,
      maxLength: 200,
    },
    is_mandatory: {
      seq: 35,
      label: 'Is Mandatory?',
      type: FieldType.Boolean,
      mandatory: true,
      listColumn: true,
    },
    standard_field: {
      seq: 40,
      label: 'Analytics Summary Field',
      type: FieldType.Options,
      listColumn: true,
      description:
        "Our analytics summarises users' star-rating responses in 4 categories - you can choose which fields in this form correspond to those categories here",
      options: [
        { id: 'content', label: 'content' },
        { id: 'delivery', label: 'delivery' },
        { id: 'admin', label: 'admin' },
        { id: 'overall', label: 'overall' },
      ],
    },
  },
};
